import { AfterContentInit, Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { GenericFilter } from 'shared';
import { GroupRoleClaim, GroupRolePermissionDto } from 'shared';
import { PermissionDto, ProjectPermissionDto, TenantPermissionDto } from 'shared';
import { ProjectGroupRolePermissionDto, ProjectGroupRolePermissionForUpdateDto } from 'shared';
import { ProjectGroupRoleDto } from 'shared';
import { documentReducer } from 'shared';
import { GroupRolePermissionService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { PermissionsService } from 'shared';
import { ProjectGroupRolePermissionService } from 'shared';
import { ProjectRolesService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'group-role-claims-dialog',
    templateUrl: './group-role-claims-dialog.component.html',
    styleUrls: ['./group-role-claims-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GroupRoleClaimsDialogComponent implements OnInit { 

  //groupRole: ProjectGroupRoleDto = new ProjectGroupRoleDto();
  groupRole!: ProjectGroupRoleDto;
  projectPermissions: ProjectPermissionDto[] = [];
  tenantdb!:string;

  _db!:string;
  _targetIsTenantDB = true;
  toDisplay = false;
  isForAdmin = false;

  constructor(private renderer: Renderer2,
    public _dialogRef: MatDialogRef<GroupRoleClaimsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectRoleService: ProjectRolesService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private projectGroupRolePermissionService: ProjectGroupRolePermissionService,
    private groupRolePermissionService: GroupRolePermissionService,
    private tenantService:TenantService,
    private permissionService: PermissionsService,
    private oauthService: OAuthServiceService) { }  

  ngOnInit(): void { 
    this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });
    //this.fetchFromTenantdb(this.data.roleId);
    //this.refresh();        

    if(this.data.projectId != null){
      this.tenantService.getProjectGroupRole(this.data.projectId, this.data.roleId, this.tenantService.currentTenantName, new GenericFilter).subscribe({
        next: (grpRole) => {
          this.groupRole = grpRole;
          console.log("-------> PGR = ", this.groupRole)

        // all possible permissions
        this.permissionService.loadProjectPermissions(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
          next:(permissionDtos:any) => { 
            this.projectPermissions = permissionDtos;
            console.log("-------> ProjPerm = ", this.projectPermissions)
            this.toDisplay = true;
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
        })

        //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADED"]}`);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
      });
    }
    else {
      this.tenantService.getProjectGroupRoleTemplate(this.data.roleId, this.tenantService.currentTenantName, new GenericFilter).subscribe({
        next: (grpRole) => {
          this.groupRole = grpRole;
          this.isForAdmin = this.groupRole.isforadmin;
          console.log("-------> PGR = ", this.groupRole)

        // all possible permissions
        this.permissionService.loadProjectPermissions(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
          next:(permissionDtos:any) => { 
            this.projectPermissions = permissionDtos;
            console.log("-------> ProjPerm = ", this.projectPermissions)
            this.toDisplay = true;
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
        })

        //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADED"]}`);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
      });

    }

  }

  refresh() {

    //if(!this._targetIsTenantDB) {      
      //          if(this._db){
      //            this.fetchFromMaindb(this.data.roleId);
    //}
    //else{
      this.fetchFromTenantdb(this.data.roleId);
    //}      
  }  

  fetchFromTenantdb(roleId: string) {
    //let db:string = this.tenantService.currentTenantName;
    // this.tenantService.loadGroupRolePermissions(roleId, this.tenantService.currentTenantName).subscribe({
      this.tenantService.getProjectGroupRole(this.data.projectId, roleId, this.tenantService.currentTenantName, new GenericFilter).subscribe({
        next: (grpRole) => {
          this.groupRole = grpRole;
          console.log("-------> PGR = ", this.groupRole)

        // all possible permissions
        this.permissionService.loadProjectPermissions(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
          next:(permissionDtos:any) => { 
            this.projectPermissions = permissionDtos;
            console.log("-------> ProjPerm = ", this.projectPermissions)
            this.toDisplay = true;
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
        })

        //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADED"]}`);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
    });
  }

  // fetchFromMaindb(roleId:string) {
  //   this.groupRolePermissionService.loadGroupRolePermissions(roleId).subscribe({
  //     next: (grpRolePermissions) => {
  //       console.log(grpRolePermissions)
  //       this.groupRolePermissions = grpRolePermissions;
  //       this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADED"]}`);
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEPERMISSIONSLOADEDERROR"]}`)
  //   });
  //}

  onChange1(permissions: string) {
    console.log("--------> project-permission change")
    console.log(permissions)
    //this.platformPermissions = platformPermissions;
    this.groupRole.permissions = permissions;

  }

  updatePGR(){
    const tenantDb = this.tenantService.currentTenantName;
    if(this.data.projectId != null){
      this.tenantService.updateProjectGroupRole(this.data.projectId, tenantDb, this.groupRole).subscribe({
        next:() => {
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEPERMISSIONUPDATED"]} `);
          this._dialogRef.close();
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEPERMISSIONUPDATEDERROR"]}`)
      });
    } else {
      this.groupRole.isforadmin = this.isForAdmin;
      this.tenantService.updateProjectGroupRoleTemplate(tenantDb, this.groupRole).subscribe({
        next:() => {
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEPERMISSIONUPDATED"]} `);
          this._dialogRef.close();
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEPERMISSIONUPDATEDERROR"]}`)
      });
    }

  }

  cancel(){
    this._dialogRef.close();
  }
}
